import React from "react";
import PropTypes from "prop-types";
import EmbedIframe from "./EmbedIframe";

const PUB_PLANNER_DASHBOARDS = [
  "campaign_activation_status",
  "campaign_delivery_status",
];

/**
    This is an iframe used for pub planner's activation & delivery status reports which is created for seperate reports based on persona of pub planner and publisher.
    It will be helpful for reduce multiple conditions based on reports and personas in single EmbadeIframe file and make code simple to understand.
*/
const EmbedIframePubPlanner = (props) => {
  return (
    <EmbedIframe
      {...props}
      modelType="pub_planner"
      dashboardIds={PUB_PLANNER_DASHBOARDS}
    />
  );
};

EmbedIframePubPlanner.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
  match: PropTypes.shape({
    params: PropTypes.shape({
      reportingType: PropTypes.string,
      reportingSubType: PropTypes.string,
    }),
  }),
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
};

export default EmbedIframePubPlanner;
